module.exports = __webpack_public_path__ + "static/media/back-new-3.fbe73d71.jpg";